import { AppSettings } from 'app/sharedcomponents/_common/constants/app.constants';
import { Component, OnInit, Output, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { overlayConfigFactory } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { SendMoneyDetail, SendMoneySteps } from '../../models/sendmoney/sendmoney';
import { UserProfileTMNIovation } from '../../models/user/user.tm.profile.model';
import { CountryService } from '../../sharedcomponents/commonservice/countrylist.service';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { AlertPopupComponent } from '../../sharedcomponents/_directive/alert-popup/alert-popup.component';
import { InfoPopupComponent } from '../../sharedcomponents/_directive/info-popup/info-popup.component';
import { SendMoneyService } from '../../_services/sendmoneyservice/sendmoneyservice';
import { AuthService } from '../../_services/userservice/auth.service';
import { Ng2DeviceService } from "ng2-device-detector";
@Component({
  selector: 'app-add-account-detail',
  templateUrl: './add-account-detail.component.html',
  styleUrls: ['./add-account-detail.component.css'],
  providers: [Modal, CountryService, AuthService]
})
export class AddAccountDetailComponent implements OnInit {
  PageFlow: any = {};
  sendMoneyDetail: SendMoneyDetail;
  countrycollection: any;
  countryName: string;
  bankDetails: any = {};
  AccountTypeList: any = [];
  minlength: number = 10;
  maxlength: number = 100;
  AccountNumberPrefix: string = '';
  private subProfile = new Subject<boolean>();
  @Output() subProfileObservable = this.subProfile.asObservable();
  userProfileTMNIovation: UserProfileTMNIovation;
  constructor(
    private router: Router,
    private modal: Modal,
    private countryserv: CountryService,
    private sendMoneyService: SendMoneyService,
    public utilitySer: utilityService,
    private auth: AuthService,
    private vcRef: ViewContainerRef,
    private deviceService: Ng2DeviceService,
    public translate: TranslateService
  ) {
    // this.sendMoneyService.getPageFlow().subscribe(data => {
    //   this.PageFlow = data;
    // });
    this.PageFlow.Value = sessionStorage.PageFlow;
    this.sendMoneyDetail = new SendMoneyDetail();
    this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
      this.sendMoneyDetail = data;
    });
    this.InitPage();
  }
  canDeactivate(): Observable<boolean> | boolean {
    if (this.sendMoneyDetail.isData == true && this.PageFlow.Value == 'sendmoney') {
      let _self=this;
      return Observable.create(observer => {
        this.modal.overlay.defaultViewContainer = this.vcRef;
        let modalData: any = {};
        let loading = false;
        modalData.Title = this.translate.instant('Common_lblConfirm');
        modalData.Message = this.translate.instant('SendMoney_navigateConfirmDesc');
        this.modal.open(InfoPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
          obj.onDestroy.subscribe(data => {
            if (modalData.next == 'yes') {
              let DeviceDetail = _self.deviceService.getDeviceInfo();
              (<any>window).firebase
                .analytics()
                .logEvent("UnfinishedTransaction", {
                  Screen: "PickupCenter",
                  Platform: AppSettings.Platform,
                  Browser: DeviceDetail.browser,
                  OSVersion: DeviceDetail.os_version,
                  AppVersion: AppSettings.Appversion
                });
              observer.next(true);
              observer.complete();
            } else {
              observer.next(false);
              observer.complete();
            }
          });
        });
      });
    }
    return true;
  }

  ngOnInit() {}
  InitPage() {
    if (this.sendMoneyDetail.bankDetails.BankName == undefined) {
      this.router.navigate(['/dashboard']);
      return;
    }
    this.bankDetails.BankName = this.sendMoneyDetail.bankDetails.BankName;
    // this.AccountTypeList = this.sendMoneyDetail.bankDetails.BankAccountTypes;
    this.bankDetails.AccountType = ''; //this.AccountTypeList[0].AccountType;
    this.bankDetails.routingNumber = 0;
    this.countrycollection = this.countryserv.getCountryListFromLocaleEx();
    const countryCode = this.sendMoneyDetail.pickupTypeDetails.countryPreference;
    const coll = this.countrycollection.filter(function(country) {
      return country.CountryCode === countryCode;
    });
    if (coll.length > 0) {
      this.bankDetails.CountryCode = coll[0].CountryCode;
      this.bankDetails.CountryName = coll[0].CountryNames[0].Name;
    }

    // this.AccountTypeList = this.sendMoneyDetail.bankDetails.BankAccountTypes.filter((x, i, a) => x.AccountType && a.indexOf(x) === i);
    let _self = this;
    let unique_array = [];
    for (let i = 0; i < this.sendMoneyDetail.bankDetails.BankAccountTypes.length; i++) {
      let prefix = this.sendMoneyDetail.bankDetails.BankAccountTypes[i].AccountNumberPrefix == '' ? '' : this.sendMoneyDetail.bankDetails.BankAccountTypes[i].AccountNumberPrefix;
      let key = this.sendMoneyDetail.bankDetails.BankAccountTypes[i].AccountType + '-' + prefix;
      if (key != '-') {
        if (unique_array.indexOf(key) == -1) {
          unique_array.push(key);

          let tObj: any = {};
          tObj.minlength = this.sendMoneyDetail.bankDetails.BankAccountTypes[i].AccountNumberMinimumLength;
          tObj.maxlength = this.sendMoneyDetail.bankDetails.BankAccountTypes[i].AccountNumberMaximumLength;

          this.sendMoneyDetail.bankDetails.BankAccountTypes[i].Validations = [];
          this.sendMoneyDetail.bankDetails.BankAccountTypes[i].Validations.push(tObj);
          this.AccountTypeList.push(this.sendMoneyDetail.bankDetails.BankAccountTypes[i]);
        } else {
          let tObj: any = {};
          tObj.minlength = this.sendMoneyDetail.bankDetails.BankAccountTypes[i].AccountNumberMinimumLength;
          tObj.maxlength = this.sendMoneyDetail.bankDetails.BankAccountTypes[i].AccountNumberMaximumLength;
          if (
            this.AccountTypeList.filter(function(element) {
              return element.AccountType == _self.sendMoneyDetail.bankDetails.BankAccountTypes[i].AccountType;
            }).length > 0
          ) {
            this.AccountTypeList.filter(function(element) {
              return element.AccountType == _self.sendMoneyDetail.bankDetails.BankAccountTypes[i].AccountType;
            })[0].Validations.push(tObj);
          }
        }
      }
    }

    this.AccountTypeList.forEach(element => {
      if (element.Validations.length > 1) {
        let minlength = 100;
        let maxlength = 0;
        element.Validations.forEach(item => {
          minlength = item.minlength < minlength ? item.minlength : minlength;
        });
        element.Validations.forEach(item => {
          maxlength = item.maxlength > maxlength ? item.maxlength : maxlength;
        });

        this.minlength = minlength;
        this.maxlength = maxlength;
        // this.minlength = element.Validations.reduce(function(res, obj) {
        //   return obj.minlength < res.minlength ? obj.minlength : res.minlength;
        // });
        // this.maxlength = element.Validations.reduce(function(res, obj) {
        //   return obj.maxlength > res.maxlength ? obj.maxlength : res.maxlength;
        // });
      } else {
        this.minlength = element.AccountNumberMinimumLength;
        this.maxlength = element.AccountNumberMaximumLength;
      }
      this.maxlength = this.maxlength - this.AccountNumberPrefix.length;
      this.maxlength = this.maxlength == 0 ? 100 : this.maxlength;
      element.minlength = this.minlength;
      element.maxlength = this.maxlength;
      if (element.minlength == element.maxlength) {
        element.equalLength = true;
      } else {
        element.equalLength = false;
      }
    });
  }

  onAcoountTypeChange(accounttype: string) {
    const _self = this;
    this.sendMoneyDetail.bankAccountTypeDetail = this.AccountTypeList.filter(function(element) {
      return element.AccountType == accounttype;
    })[0];

    this.bankDetails.AccountNumber = '';
    this.bankDetails.ConfirmAccountNumber = '';
    this.AccountNumberPrefix = this.sendMoneyDetail.bankAccountTypeDetail.AccountNumberPrefix;

    if (this.sendMoneyDetail.bankAccountTypeDetail.Validations.length > 1) {
      // this.minlength = this.sendMoneyDetail.bankAccountTypeDetail.Validations.reduce(function(res, obj) {
      //   return obj.minlength < res.minlength ? obj.minlength : res.minlength;
      // });
      // this.maxlength = this.sendMoneyDetail.bankAccountTypeDetail.Validations.reduce(function(res, obj) {
      //   return obj.maxlength > res.maxlength ? obj.maxlength : res.maxlength;
      // });
      let minlength = 100;
      let maxlength = 0;
      this.sendMoneyDetail.bankAccountTypeDetail.Validations.forEach(item => {
        minlength = item.minlength < minlength ? item.minlength : minlength;
      });
      this.sendMoneyDetail.bankAccountTypeDetail.Validations.forEach(item => {
        maxlength = item.maxlength > maxlength ? item.maxlength : maxlength;
      });

      this.minlength = minlength;
      this.maxlength = maxlength;
    } else {
      this.minlength = this.sendMoneyDetail.bankAccountTypeDetail.AccountNumberMinimumLength;
      this.maxlength = this.sendMoneyDetail.bankAccountTypeDetail.AccountNumberMaximumLength;
    }
    this.maxlength = this.maxlength - this.AccountNumberPrefix.length;
    this.maxlength = this.maxlength == 0 ? 100 : this.maxlength;
  }
  AddAccountDetail() {
    let self = this;
    let flagValidation = false;
    this.sendMoneyDetail.bankAccountTypeDetail.Validations.filter(function(res) {
      if (self.bankDetails.AccountNumber.length >= res.minlength && self.bankDetails.AccountNumber.length <= res.maxlength) {
        flagValidation = true;
        return;
      }
    });
    if (!flagValidation) {
      let modalData: any = {};
      modalData.Action = this.translate.instant('Common_lblOk');
      modalData.Title = this.translate.instant('Common_lblInfo');
      let Message = this.translate.instant('Common_lblAccountNumberEntered');
      let index = 1;
      this.sendMoneyDetail.bankAccountTypeDetail.Validations.forEach(element => {
        Message += '<br/>' + index + '. ' + this.translate.instant('Common_lblAccountNumberMin');
        Message += ' ' + element.minlength + ' ' + this.translate.instant('Common_lblDigitAndMax');
        Message += ' ' + element.maxlength + ' ' + this.translate.instant('Common_lblDigit');
        index++;
      });

      modalData.Message = Message;
      this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
        obj.onDestroy.subscribe(data => {});
      });
      return false;
    }

    this.sendMoneyDetail.agentDetails.AgentName = this.sendMoneyDetail.bankDetails.BankName;
    this.sendMoneyDetail.pickupCenterDetails.imgData = this.sendMoneyDetail.bankDetails.imageData;
    this.sendMoneyDetail.agentDetails.ImageData = this.sendMoneyDetail.bankDetails.imageData;
    this.sendMoneyDetail.pickupCenterDetails.Currency = this.sendMoneyDetail.bankDetails.RequestCureencyCode;

    this.sendMoneyDetail.agentDetails.AccountType = this.sendMoneyDetail.bankAccountTypeDetail.AccountType;
    // this.sendMoneyDetail.agentDetails.CityTo = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].LocationCity; // some time city comes as an * and null thats y we commented this
    this.sendMoneyDetail.agentDetails.CountryTo = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].LocationCountryCode;
    this.sendMoneyDetail.agentDetails.CurrencyTo = this.sendMoneyDetail.bankDetails.RequestCureencyCode;
    this.sendMoneyDetail.agentDetails.DeliveryMethod = this.sendMoneyDetail.pickupTypeDetails.pickupType;
    this.sendMoneyDetail.agentDetails.LocationId = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].LocationId;
    this.sendMoneyDetail.agentDetails.PayingAgentId = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].PayingAgentId;
    // this.sendMoneyDetail.agentDetails.StateTo = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].LocationStateCode;

    let feeRateDetails = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].FeeRateDetails.filter(function(frd) {
      return frd.ProgramId == self.sendMoneyDetail.agentDetails.ProgramId;
    });
    this.sendMoneyDetail.agentDetails.ProgramId = feeRateDetails[0].ProgramId;
    this.sendMoneyDetail.branchDetails.CustomerFee = feeRateDetails[0].CustomerFee;
    this.sendMoneyDetail.branchDetails.RateCustomer = feeRateDetails[0].RateCustomer;

    this.sendMoneyDetail.branchDetails.LocationAddress1 = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].LocationAddress1;
    this.sendMoneyDetail.branchDetails.LocationAddress2 = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].LocationAddress2;
    this.sendMoneyDetail.branchDetails.LocationBranchNumber = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].LocationBranchNumber;
    this.sendMoneyDetail.branchDetails.LocationCity = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].LocationCity;
    this.sendMoneyDetail.branchDetails.LocationCountryCode = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].LocationCountryCode;
    this.sendMoneyDetail.branchDetails.LocationDirections = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].LocationDirections;
    this.sendMoneyDetail.branchDetails.LocationId = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].LocationId;
    this.sendMoneyDetail.branchDetails.LocationLatitude = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].LocationLatitude;
    this.sendMoneyDetail.branchDetails.LocationLongitude = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].LocationLongitude;
    this.sendMoneyDetail.branchDetails.LocationName = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].LocationName;
    this.sendMoneyDetail.branchDetails.LocationNotes = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].LocationNotes;
    this.sendMoneyDetail.branchDetails.LocationPostalCode = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].LocationPostalCode;
    this.sendMoneyDetail.branchDetails.LocationStateCode = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].LocationStateCode;
    this.sendMoneyDetail.branchDetails.MaximumLocalAmount = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].MaximumLocalAmount;
    this.sendMoneyDetail.branchDetails.MaximumLocalAmountExcludeFee = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].MaximumLocalAmountExcludeFee;
    this.sendMoneyDetail.branchDetails.MinimumDenomination = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].MinimumDenomination;
    this.sendMoneyDetail.branchDetails.PayingAgentId = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].PayingAgentId;
    this.sendMoneyDetail.branchDetails.PayingAgentName = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].PayingAgentName;
    this.sendMoneyDetail.branchDetails.PickupRequirements = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].PickupRequirements;

    this.sendMoneyDetail.branchDetails.Restrictions = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].Restrictions;
    this.sendMoneyDetail.branchDetails.ScheduleThisWeek = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].ScheduleThisWeek;
    this.sendMoneyDetail.branchDetails.ScheduleThisWeek2 = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].ScheduleThisWeek2;

    this.sendMoneyDetail.branchDetails.SpecialInstructions = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].SpecialInstructions;

    this.sendMoneyDetail.branchDetails.Validation.BankAccountDetail = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].BankAccountValidationCallAvailable;
    this.sendMoneyDetail.branchDetails.Validation.IsBankCityRequired = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].IsBankCityRequired;
    this.sendMoneyDetail.branchDetails.Validation.IsBankCodeRequired = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].IsBankCodeRequired;
    this.sendMoneyDetail.branchDetails.Validation.IsBankNameRequired = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].IsBankNameRequired;
    this.sendMoneyDetail.branchDetails.Validation.IsBeneficiaryAddressRequired = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].IsBeneficiaryAddressRequired;
    this.sendMoneyDetail.branchDetails.Validation.IsBeneficiaryIdentificationRequired = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].IsBeneficiaryIdentificationRequired;
    this.sendMoneyDetail.branchDetails.Validation.isBeneficiaryLastName2Required = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].IsBeneficiaryLastName2Required;
    this.sendMoneyDetail.branchDetails.Validation.IsBeneficiaryPhoneRequired = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].IsBeneficiaryPhoneRequired;
    this.sendMoneyDetail.branchDetails.Validation.IsBeneficiaryRelationRequired = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].IsBeneficiaryRelationRequired;
    this.sendMoneyDetail.branchDetails.Validation.IsBeneficiaryValidAddressRequired = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].IsBeneficiaryValidAddressRequired;
    this.sendMoneyDetail.branchDetails.Validation.IsBeneficiaryZipCodeRequired = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].IsBeneficiaryZipCodeRequired;
    this.sendMoneyDetail.branchDetails.Validation.IsCustomerEmployerRequired = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].IsCustomerEmployerRequired;
    this.sendMoneyDetail.branchDetails.Validation.IsCustomerOccupationRequired = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].IsCustomerOccupationRequired;
    this.sendMoneyDetail.branchDetails.Validation.IsFundSourceRequired = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].IsFundSourceRequired;
    this.sendMoneyDetail.branchDetails.Validation.IsTransferReasonRequired = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].IsTransferReasonRequired;

    this.sendMoneyDetail.bankAccountDetails.BankAccountNumber = this.bankDetails.AccountNumber;
    this.sendMoneyDetail.bankAccountDetails.BankAccountType = this.sendMoneyDetail.bankAccountTypeDetail.AccountType;
    this.sendMoneyDetail.bankAccountDetails.BankCity = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].LocationCity;
    this.sendMoneyDetail.bankAccountDetails.routingNumber = this.bankDetails.routingNumber;
    this.sendMoneyDetail.bankAccountDetails.BankCountry = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].LocationCountryCode;
    this.sendMoneyDetail.bankAccountDetails.BankName = this.sendMoneyDetail.bankDetails.BankName;
    this.sendMoneyDetail.bankAccountDetails.BankId = this.sendMoneyDetail.bankDetails.BankId;
    this.sendMoneyDetail.bankAccountDetails.BankState = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].LocationStateCode;
    this.sendMoneyDetail.bankAccountDetails.BankZipCode = this.sendMoneyDetail.bankAccountTypeDetail.PayingAgents[0].LocationPostalCode;
    this.sendMoneyDetail.paymentDetails.processingFee = parseFloat(this.sendMoneyDetail.branchDetails.CustomerFee.toString());
    this.sendMoneyDetail.paymentDetails.exchangeRate = this.sendMoneyDetail.branchDetails.RateCustomer.toString();
    this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);

    if (this.PageFlow.Value == 'repeatorder') {
      if (sessionStorage.RepeatOrderFlow != undefined && sessionStorage.RepeatOrderFlow != '') {
        this.router.navigate(['/' + sessionStorage.RepeatOrderFlow]);
      } else {
        this.router.navigate(['/repeatorderlist']);
      }
    } else {
      this.sendMoneyService.setModalPopup(SendMoneySteps.Beneficiary);
      this.router.navigate(['/sendmoney']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sendMoney/_add-account-detail/add-account-detail.component.ts